<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Danh sách học phần" :link="[{ text: 'Học phần', href: '../grades' }]" />
      </div>
      <div class="flex-center">
        <v-btn elevation="0" @click="createGrade = !createGrade" dark color="#0D47A1" class="text-none">
          <v-icon left>add</v-icon>{{ addButtonText }}
        </v-btn>
      </div>
    </div>
    <new-grade-dialog :state="createGrade" />
    <v-card v-if="$auth.role.type !== 'teacher'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <FilterGrade @onFilterChanged="refresh" />
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <v-data-table
        no-data-text="Không có dữ liệu"
        disable-sort
        :headers="headers"
        :items="grades"
        :footer-props="{ 'items-per-page-text': 'Số dòng mỗi trang', 'items-per-page-all-text': 'Tất cả' }"
      >
        <template v-slot:[`footer.page-text`]="items">
          {{ items.pageStart }} - {{ items.pageStop }} trên tổng
          {{ items.itemsLength }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <grade-list-actions :selected="item"> </grade-list-actions>
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on" style="text-decoration: none; white-space: nowrap">
                <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/grades/' + item.id">{{
                  item.title
                }}</router-link>
              </div>
            </template>
            <span>Chi tiết học phần</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import NewGradeDialog from '@/modules/grade/NewGradeDialog.vue'
import GradeListActions from '@/modules/grade/GradeListActions.vue'
import utils from '@/plugins/utils'
import FilterGrade from '@/modules/grade/FilterGrade.vue'

export default {
  components: {
    NewGradeDialog,
    Breadcrumbs,
    GradeListActions,
    FilterGrade,
  },
  props: {
    role: String,
  },
  data() {
    return {
      headers: [
        {
          text: 'Bộ môn',
          value: 'academicLevel.title',
        },
        {
          text: 'Chương trình đào tạo',
          value: 'division.title',
        },
        {
          text: 'Mã học phần',
          value: 'code',
        },
        {
          text: 'Tên học phần',
          value: 'title',
        },
        {
          text: 'Tổng số buổi',
          value: 'totalDate',
          align: 'end',
          width: '120px',
        },
        {
          text: 'Thao tác',
          value: 'actions',
          align: 'center',
          width: '100px',
        },
      ],
      createGrade: false,
      selected: {},
    }
  },

  computed: {
    ...mapState('grade', ['grades', 'query']),
    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'THÊM HỌC PHẦN'
      }
    },
  },
  async created() {
    await this.fetchAcademics({ _sort: 'title:ASC' })
    await this.refresh()
  },
  beforeDestroy() {
    this.setQuery({})
  },
  methods: {
    ...mapActions({
      fetchGrades: 'grade/fetchGrades',
      setQuery: 'grade/setQuery',
      fetchAcademics: 'AcademicLevel/fetchAcademics',
    }),
    async refresh() {
      const checkLocalQuery = JSON.parse(localStorage.getItem('grade-query'))
      let filterParams = { ...this.query }
      if (checkLocalQuery) filterParams = { ...filterParams, ...checkLocalQuery }
      await this.fetchGrades({ _sort: 'academicLevelIndex:asc,divisionIndex:asc,createdAt:asc', ...filterParams })
      setTimeout(() => {
        localStorage.removeItem('grade-query')
      }, 3000)
    },
    onGradeSelected(grade) {
      this.setGrade(grade)
    },
    exportExcel() {
      const excelHeader = this.headers.map(({ text, value }) => ({ text, value }))
      utils.exportExcel(this.grades, excelHeader, 'Grade_List')
    },
  },
}
</script>
